module.exports = __webpack_public_path__ + "media/images/admin/icons/volume-x-a190bf73596b92d5debd68b6176a54a4.svg";